import React, { useState, useContext, useEffect } from 'react';
import { IconButton, Menu, MenuItem, Avatar, Typography, Box, Divider, Tooltip } from '@mui/material';
import { Context } from '../../App';
import { Navigate, useNavigate } from 'react-router-dom';

const AccountMenu = () => {
    const navigate = useNavigate();
    const { isConnected, setIsConnected, userId, setUserId } = useContext(Context);
    const [user, setUser] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleDeconnect = () => {
        handleClose();
        // Clear user data and local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setIsConnected(false);
        setUserId(localStorage.getItem('anonUserId') || null);
    }

    useEffect(() => {
        // Check if user is connected and update state accordingly
        if (!userId || !isConnected) {
            setIsConnected(false);
            return;
        }

        fetch(`${process.env.REACT_APP_API_URL}/user/`+userId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(response => {
            const token = response.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if (response.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                setIsConnected(false);
                throw new Error('Unauthorized');
            }

            if (response.ok) {
                return response.json();
            } else {
                setIsConnected(false);
                throw new Error(response.statusText || 'Failed to fetch user data');
            }
        })
        .then(data => {
            setUser(data);
        })
        .catch(error => {
            console.error('Error fetching user data:', error);
            setIsConnected(false);
        });
    }, [userId, isConnected])

    return (
        <>
        {!!user && <Tooltip title="Mon compte">
            <IconButton
            onClick={handleOpen}
            onMouseEnter={handleOpen}
            size="large"
            edge="end"
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            >
            <Avatar sx={{ width: 42, height: 42, bgcolor: 'focus.main', color:'white', fontSize: 16, fontWeight:'bold' }}>
                {(user.nom.charAt(0) + user.prenom.charAt(0)).toUpperCase()}
            </Avatar>
            </IconButton>
        </Tooltip>}

        <Menu
            id="account-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            onMouseLeave={handleClose}
            slotProps={{ list: { onMouseLeave: handleClose} }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            {/* En-tête utilisateur */}
            <Box px={2} py={1}>
                <Typography variant="body2" color="text.secondary" fontWeight="bold">
                    Connecté en tant que :
                </Typography>
                <Typography variant="body2" color="text.primary">
                    {user?.mail}
                </Typography>
            </Box>

            <Divider sx={{ my: 1 }} />

            {/* Liens du menu */}
            <MenuItem onClick={()=>{handleClose(); navigate('/compte')}}>Mon compte</MenuItem>
            <MenuItem onClick={()=>{handleClose(); navigate('/mes_billets')}}>Mes billets</MenuItem>

            {user?.role!=='user' && (
            <MenuItem onClick={handleClose} sx={{ fontWeight: 'bold' }}>
                <a href={process.env.REACT_APP_ADM_WEB_APP_URL} style={{textDecoration: 'none', color:'inherit'}}>Administration</a>
            </MenuItem>
            )}

            <Divider sx={{ my: 1 }} />

            <MenuItem onClick={handleDeconnect}>Se déconnecter</MenuItem>
        </Menu>
        </>
    );
};

export default AccountMenu;
